import type { ButtonSize } from './Button.types';

export type SizeConfig = {
  borderRadius: string;
  borderWidth: string;
  fontSize: string;
  height: string;
  loaderSize: string;
  paddingX: string;
  paddingY: string;
};

export const BUTTON_SIZES: Record<ButtonSize, SizeConfig> = {
  lg: {
    borderRadius: 'rounded-xl!',
    borderWidth: 'border-2',
    fontSize: 'text-p-md',
    height: 'h-[48px]', // 48px not in spacing tokens
    loaderSize: '24px',
    paddingX: 'px-md',
    paddingY: 'py-sm',
  },
  md: {
    borderRadius: 'rounded-xl-plus!',
    borderWidth: 'border-2',
    fontSize: 'text-p-sm',
    height: 'h-xxl',
    loaderSize: '18px',
    paddingX: 'px-md',
    paddingY: 'py-sm',
  },
  sm: {
    borderRadius: 'rounded-lg-plus!',
    borderWidth: 'border-1.5',
    fontSize: 'text-p-sm',
    height: 'h-xl',
    loaderSize: '14px',
    paddingX: 'px-sm',
    paddingY: 'py-xs',
  },
} as const;
